import { PostHogProvider as PHProvider } from '@posthog/react';
import posthog from 'posthog-js';
import { ReactNode } from 'react';
import { esEntradaDeImpersonacion } from '../utils/impersonation';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
const POSTHOG_ENABLED = process.env.REACT_APP_POSTHOG_ENABLED === 'true';
const POSTHOG_ENVIRONMENT = process.env.REACT_APP_POSTHOG_ENVIRONMENT || 'development';

// 🔴 Al cargar el módulo, no en un efecto: React vacía los efectos de hijo a padre, así que un
// `init` en el efecto del proveedor llegaba DESPUÉS que los de la página. Lo que hiciera un hijo
// al montarse se perdía sin aviso: el `capture` de `AvisoNavegador`, o el `reset` +
// `opt_out_capturing` de una impersonación (sin `init`, el opt-out se guarda con una clave vacía
// que PostHog ignora, y la impersonación se registraba igual).
if (POSTHOG_ENABLED && POSTHOG_KEY) {
	posthog.init(POSTHOG_KEY, {
		api_host: POSTHOG_HOST,
		// En una impersonación, la página vista inicial se colaría antes del opt-out del login.
		capture_pageview: !esEntradaDeImpersonacion(),
		capture_pageleave: true,
		autocapture: true
	});
	posthog.register({ environment: POSTHOG_ENVIRONMENT, app: 'chirigota' });
}

export function PostHogWrapper({ children }: { children: ReactNode }) {
	if (!POSTHOG_ENABLED || !POSTHOG_KEY) {
		return <>{children}</>;
	}

	return <PHProvider client={posthog}>{children}</PHProvider>;
}
